import { $api } from "../../../http/index";

export const getLeagues = (date, tab) => {
  return $api
    .get(tab === "Live" ? `/fixture/list/live?utc=3` : `fixture/list?date=${date}&utc=3`)
    .then((response) => response.data);
};